import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { combineTitleSegments, getTitleSegments } from 'src/util/angular/ng-router-helpers';

@Injectable({
  providedIn: 'root',
})
export class RouteTitleService {
  constructor(
    private _titleService: Title,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
  ) {}

  public init() {
    this._router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        map(() => this._activatedRoute.snapshot),
        filter((r) => r.outlet === 'primary'),
        map((r) => getTitleSegments(r)),
        filter((ts) => ts.length > 0),
        map(combineTitleSegments),
      )
      .subscribe((title) => {
        this._titleService.setTitle(title);
      });
  }
}
